// extracted by mini-css-extract-plugin
export default {"inputNumber":"ConnectionMonitoringModal_inputNumber__JEeJB"};